import { useEffect, useState } from "react";
import { ShieldCheck } from "lucide-react";
import { api } from "@/lib/api";
import PageHeader from "@/components/PageHeader";
import { FadeIn } from "@/components/Reveal";
import SEO from "@/components/SEO";

export default function Certifications() {
  const [items, setItems] = useState(null);

  useEffect(() => {
    api.get("/certifications").then((r) => setItems(r.data)).catch(() => setItems([]));
  }, []);

  if (!items) return <div className="min-h-screen bg-[#0A0A0A]" data-testid="certifications-loading" />;

  return (
    <main data-testid="certifications-page">
      <SEO
        title="Certifications & Credentials — Catalyst Petrochem LLP"
        description="ISO 9001:2015 certified, NABL-accredited testing partnerships, NHAI/PWD approvals, and full statutory registrations for source pre-qualification."
        path="/certifications"
      />
      <PageHeader
        index="04"
        tag="Certifications & Credentials"
        title="Compliant. Certified. Verified."
        description="ISO 9001:2015 certified systems, NABL-accredited testing partnership, and full statutory registrations — documentation available for pre-qualification and source approval."
      />
      <section className="px-6 py-20 md:px-12 md:py-28 lg:px-20">
        <div className="grid gap-px border border-white/10 bg-white/10 sm:grid-cols-2 lg:grid-cols-3" data-testid="certifications-grid">
          {items.map((c, i) => (
            <FadeIn key={c.id} delay={i * 0.05} className="group bg-[#0A0A0A] p-10 transition-colors duration-300 hover:bg-[#141414]">
              <ShieldCheck className="h-6 w-6 text-brand" />
              <h2 className="mt-6 font-display text-2xl font-semibold uppercase tracking-normal" data-testid={`cert-name-${i}`}>
                {c.name}
              </h2>
              <p className="mt-3 font-mono text-[10px] uppercase tracking-[0.2em] text-brand">{c.number}</p>
              <p className="mt-4 text-sm leading-relaxed text-neutral-500">{c.detail}</p>
              <p className="mt-6 border-t border-white/5 pt-4 font-mono text-[10px] uppercase tracking-[0.15em] text-neutral-500">
                {c.validity}
              </p>
            </FadeIn>
          ))}
        </div>
      </section>
    </main>
  );
}
